module.exports = __webpack_public_path__ + "static/psychic-interior-04-0fe0404ed964c403e996c42eee509c29.jpg";